import PapercleanConfigurazioneDizionariListPage from "./pages/PapercleanConfigurazioneDizionariListPage.vue";
import PapercleanConfigurazioneDizionariViewPage from "./pages/PapercleanConfigurazioneDizionariViewPage.vue";
import PapercleanAnagraficaListPage from "./pages/PapercleanAnagraficaListPage.vue";
import PapercleanConfigurazioneIvaListPage from "./pages/PapercleanConfigurazioneIvaListPage.vue";
import PapercleanConfigurazioneGruppiListPage from "./pages/PapercleanConfigurazioneGruppiListPage.vue";
import PapercleanConfigurazioneMarcheListPage from "./pages/PapercleanConfigurazioneMarcheListPage.vue";
import PapercleanConfigurazioneCategorieListPage from "./pages/PapercleanConfigurazioneCategorieListPage.vue";
import PapercleanArticoliListPage from "./pages/PapercleanArticoliListPage.vue";
import PapercleanAnagraficaTipiPage from "./pages/PapercleanAnagraficaTipiPage.vue";
import PapercleanDocumentiTipiPage from "./pages/PapercleanDocumentiTipiPage.vue";
import PapercleanDocumentiListPage from "./pages/PapercleanDocumentiListPage.vue";
import PapercleandArticoliEditPage from "./pages/PapercleandArticoliEditPage.vue";
import PapercleanDocumentiTrasformaEditPage from "./pages/PapercleanDocumentiTrasformaEditPage.vue";
import PapercleanDocumentiMobileListPage from "./pages/PapercleanDocumentiMobileListPage.vue";

export default {
PapercleanConfigurazioneDizionariListPage,
PapercleanConfigurazioneDizionariViewPage,
PapercleanAnagraficaListPage,
PapercleanConfigurazioneIvaListPage,
PapercleanConfigurazioneGruppiListPage,
PapercleanConfigurazioneMarcheListPage,
PapercleanConfigurazioneCategorieListPage,
PapercleanArticoliListPage,
PapercleanAnagraficaTipiPage,
PapercleanDocumentiTipiPage,
PapercleanDocumentiListPage,
PapercleandArticoliEditPage,
PapercleanDocumentiTrasformaEditPage,
PapercleanDocumentiMobileListPage,
};
